window.$ = jQuery;
var $ = window.jQuery;
var scrollMonitor = require('scrollmonitor');
var objectFitImages = require("object-fit-images");
var fitvids = require('fitvids');


$(document).ready(function () {
    initAnimation();
    initMobileNav();
    initNewsFilter();
    initNewsExpanders();
    initPeopleFilter();
    calcPeopleHeight();
    initPeopleModal();
    initAdjustSectionHeight();
    addExternalLinkIcon();
    objectFitImages();
    smoothScroll();
    lastSectionBottomMargin();
    fitvids('.basic-content, .full-width-video, .single-post .content__body video');

    if (!$('body').hasClass('page-template-page-disclaimer')) {
        initStickyNav();
        getSharePriceData();
    }
});

$("body").on("click", "a[href^=http]", function () {
    if (this.href.indexOf(location.hostname) == -1) {
        $(this).attr("target", "_blank");
    }
});

$(document).on('DOMContentLoaded', function () {
    var canHover = !(matchMedia('(hover: none)').matches);
    if (canHover) {
        $('.people-list__person').addClass('no-touch');
    }
})

$(window).on('resize', function () {

    //remove mobile menu
    if (window.innerWidth > 767) {
        $('.mobile-nav__ham').removeClass('active');
        $('.mobile-nav__menu').removeClass('open');
    }
    calcPeopleHeight();
    initAdjustSectionHeight();
    if ($(".modal__content").length) {
        peopleWindowCheck();
    }
})

function addExternalLinkIcon() {
    var hostname = window.location.hostname;
    $('.menu-item').each(function () {
        let link = $(this).find('a');

        if (link[0].hostname !== window.location.hostname) {
            $(this).addClass('external-link');
            $(this).append('<i class="fa fa-external-link"></i>');
        }
    })
}

function addChildrenClass() {
    $('#menu-primary-navigation > .menu-item').each(function () {
        if ($(this).children().hasClass("sub-menu")) {
            $(this).addClass('menu-item-has-children');
        }
    })
}

addChildrenClass();

var initMobileNav = function () {
    $('.mobile-nav__ham').on('click', function () {
        $(this).toggleClass('active');

        $('.mobile-nav__menu').toggleClass('open');
    })

    $('#menu-primary-navigation--mobile i').on('click', function () {
        $(this).parents().find('.menu-item-has-children').toggleClass("active");
    })
}



var initStickyNav = function () {
    let navPosition = $('.site-header').height();

    $(window).on('scroll', function () {

        if (navPosition / 2 < $(window).scrollTop()) {
            $('.site-header').addClass('is-sticky');
        } else {
            $('.site-header').removeClass('is-sticky');
        }
    })
}

var initAdjustSectionHeight = function () {
    let serviceHeight = $('.service-listing--wrapper').height();
    $('.service-listing').css('min-height', serviceHeight);

}

var initStatsAnimation = function () {

    $('.stats__number .zero').each(function () {
        let endNumber = parseInt($(this).parents('.stats__number').find('.number').text());
        $(this).animateNumber({
            number: endNumber,
            easing: 'linear',
        }, 2000);
    })
}

var updateUrlParameter = function (e, r, a) {
        var t = e.indexOf("#"),
            i = -1 === t ? "" : e.substr(t);
        e = -1 === t ? e : e.substr(0, t);
        var s = new RegExp("([?&])" + r + "=.*?(&|$)", "i"),
            p = -1 !== e.indexOf("?") ? "&" : "?";
        a
            ?
            (e = e.match(s) ?
                e.replace(s, "$1" + r + "=" + a + "$2") :
                e + p + r + "=" + a) :
            ("?" ===
                (e = e.replace(new RegExp("([?&]?)" + r + "=[^&]*", "i"), "")).slice(
                    -1,
                ) && (e = e.slice(0, -1)),
                -1 === e.indexOf("?") && (e = e.replace(/&/, "?"))),
            pushUrl(e + i);
    },
    pushUrl = function (e) {
        if (history.pushState) {
            var r = e;
            window.history.pushState({
                path: r
            }, "", r);
        }
    };

function initNewsFilter() {
    let currentURL = window.location.href;
    $('select[name="news-filter"] option').each(function () {
        if ($(this).val() == currentURL) {
            $(this).attr('selected', true);
            console.log('true');
        }
    })
    $('select[name="news-filter"]').on("change", function (e) {
        e.preventDefault();
        var type = $(this).attr("name"),
            val = $(this).val();
        if (val == '') {
            window.location.href = '/documents/';
        } else {
            window.location.href = val;
        }
    });
}

function initNewsExpanders() {
    if( $('.category-list-container .expander').length ) {
        $('.category-list-container .expander-toggle').on('click', function(e){
            e.preventDefault();
            $(this).parents('.expander').toggleClass('active');
        });
    }

    $('.show-document-disclaimer').on('click', function(e){
        e.preventDefault();
        let target = $(this).attr('href');
        $('.document-disclaimer .confirm-button').attr('href', target);
        $('.document-disclaimer').addClass('show');
    });

    $('.document-disclaimer .exit').on('click', function(e){
        e.preventDefault();
        $('.document-disclaimer').removeClass('show');
        $('.document-disclaimer .confirm-button').attr('href', '#');
    });

    $('.document-disclaimer .confirm-button').on('click', function(e){
        $('.document-disclaimer').removeClass('show');
    });
}


function initPeopleFilter() {
    $('select[name="people-filter"]').on("change", function () {
        var type = $(this).attr("name"),
            val = $(this).val();
        updateUrlParameter(window.location.href, type, val);

        $(".people-list__row-wrapper.hide").removeClass("hide");

        $(".people-list__row-wrapper").each(function () {
            if ($(this).attr("id") != val) {
                $(this).fadeOut(200);
            } else {
                $(this).fadeIn(200);
            }
        });
        if (val == "") {
            $(".people-list__row-wrapper").fadeIn(200);
        }
    });
}

function calcPeopleHeight() {
    $(".people-list__person").each(function () {
        let originalHeight = $(this).outerHeight();
        $(this).attr("data-original-height", originalHeight);
    });
}

function initPeopleModal() {
    let modal;

    function toggleModal() {
        $('.people-list__person.caret').removeClass('caret');
        $(".person__image.active").removeClass("active");
        $(".person__modal").remove();
        let modalImage = $(this).find(".person__image");
        let person = $(this);

        createModal($(this));

        let modalHeight = $(".modal__content")[0].scrollHeight;

        setTimeout(function () {
            modalImage.addClass("active");
            person.addClass('caret');
        }, 100);

        $(".person__modal").css({
            "max-height": modalHeight,
        });

        if (window.innerWidth < 767) {
            let description = $(this).find(".person__description");
            let desHeight = description[0].scrollHeight;
            let originalHeight = $(this).attr("data-original-height");
            const totalHeight = parseInt(originalHeight) + desHeight;

            $(".person__image").removeClass("active");

            if (!$(this).hasClass("active")) {
                $(".people-list__person.active")
                    .removeClass("active")
                    .css("height", "auto")
                    .find(".person__description")
                    .css("max-height", "");
                $(this).css("height", totalHeight + 90);
                $(this)
                    .find(".person__image")
                    .addClass("active");
                description.css("max-height", desHeight + 90);
                description.css("padding", '15px');
                $(this).addClass("active");
            } else {
                $(".people-list__person").css("height", originalHeight);
                $(".person__description").css("max-height", "");
                $('.person__description').css("padding", '0');
                $(this).removeClass("active");
            }
        }
    }

    function createModal(ele) {
        let row = ele.closest(".people-list__row");
        let name = ele.find(".person__name").text();
        let position = ele.find(".person__title").text();
        let description = ele.find(".person__description").html();

        modal = `

        <div class="person__modal">
            <div class="modal__content">
                <div class="modal__exit">
                    <i class="fal fa-times"></i>
                </div>
                <h3 class="person__modal--name">${name}</h3>
                <div class="person__modal--description wysiwyg-content">
                    <p class="person__modal--title">${position}</p>
                    ${description}
                </div>
            </div>
        </div>
        `;

        row.after(modal);

        $(".modal__exit").on("click", function () {
            $(".person__modal").css("max-height", 0);
            setTimeout(function () {
                $(".person__modal").remove();
                $("html, body").animate({
                        scrollTop: $(".person__image.active").offset().top - 100,
                    },
                    500,
                );
                $(".person__image.active").removeClass("active");
                $('.people-list__person.caret').removeClass('caret');
            }, 200);
        });

        if (window.innerWidth > 767) {
            setTimeout(function () {
                $("html, body").animate({
                        scrollTop: $(".person__modal").offset().top - 200
                    },
                    500,
                );
            });
        } else {
            // if ( $('.person__image.active').length ) {
            setTimeout(function () {
                $("html, body").animate({
                        scrollTop: $(".person__image.active").offset().top
                    },
                    500,
                );
            });
            // }
        }
        peopleWindowCheck();
    }
    $(".people-list__person").on("click", toggleModal);
}

function peopleWindowCheck() {
    if (window.innerWidth > 767) {
        $(".people-list__person").css("height", "auto");

        let modalHeight = $(".modal__content")[0].scrollHeight;

        $(".person__modal").css({
            "max-height": modalHeight,
        });
    }
}

function initAnimation() {
    $('.hero__content em').addClass('animate');

    $('.disclaimer-intro, .disclaimer-wrapper').addClass('animate');

    var emText = scrollMonitor.create($('.emphasized-text'), -150);
    emText.enterViewport(function () {
        $('.emphasized-text__content').addClass('animate');
    })

    var basicContent = scrollMonitor.create($('.basic-content'), -150);
    basicContent.enterViewport(function () {
        $('.basic-content .container').addClass('animate');
        $('.basic-content__wysiwyg-content').addClass('animate');
    })

    var serviceList = scrollMonitor.create($('.service-listing'), -150);
    serviceList.enterViewport(function () {
        $('.service-listing__list').addClass('animate');
        let timer = 200;
        $('.service-listing__list li').each(function (index) {
            if (index == 0) {
                $(this).addClass('animate');
            }
            addAnimateClass($(this));
            timer += 300;
        })

        function addAnimateClass(ele) {
            setTimeout(function () {
                ele.addClass('animate');
            }, timer);
        }
    })

    var quote = scrollMonitor.create($('.quote'), -150);
    quote.enterViewport(() => {
        $('.quote__image').addClass('animate');
        $('.quote__content').addClass('animate');
    })


    $('.news-item').each(function () {
        var newsList = scrollMonitor.create($(this), -50);
        newsList.enterViewport(() => {
            $(this).addClass('animate');
        })
    })

    var contentWithBackground = scrollMonitor.create($('.content-with-background'), -250);
    contentWithBackground.enterViewport(() => {
        $('.content-with-background--wrapper').addClass('animate');
    })

    var contentWithBackground = scrollMonitor.create($('.content-with-map'), -250);
    contentWithBackground.enterViewport(() => {
        $('.content-with-map--wrapper').addClass('animate');
    })

    var stats = scrollMonitor.create($('.stats__number'), -150);
    stats.enterViewport(() => {
        initStatsAnimation();
        stats.destroy();
    })

    var contentWithImagery = scrollMonitor.create($('.content-with-imagery'), -150);
    contentWithImagery.enterViewport(() => {
        $('.content-with-imagery__text-wrapper').addClass('animate');
        let timer = 200;
        $('.logo').each(function (index) {
            if (index == 0) {
                $(this).addClass('animate');
            }
            addAnimateClass($(this));
            timer += 300;
        })

        function addAnimateClass(ele) {
            setTimeout(function () {
                ele.addClass('animate');
            }, timer);
        }
    });

    var cta = scrollMonitor.create($('.cta'), -150);
    cta.enterViewport(() => {
        $('.cta-content--wrapper').addClass('animate');
    })
}

function smoothScroll() {
    let hash = window.location.hash;
    setTimeout(function () {
        window.scrollTo(0, 0);
    }, 1);
    if (hash) {
        $("html, body").animate({
            scrollTop: $(hash).offset().top - 100
        }, 1000);
    }
}

function lastSectionBottomMargin() {
    if ($('.site-footer').prev().hasClass('news-listing__wrapper') || $('.site-footer').prev().hasClass('page-section--people-listing')) {
        $('.site-footer').prev().css('margin-bottom', 0);
    } else {
        $('.site-footer').prev().css('margin-bottom', '130px');
    }
    if ($('.site-footer').prev().hasClass('page-section--news-listing')) {
        $('.site-footer').prev().addClass('last-item');
        $('.site-footer').prev().css('margin-bottom', 0);
    }
}

function constructDate(ele) {
    let dateArray = ele.Date.split('/');
    const monthNames = ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];
    let month = monthNames[parseInt(dateArray[1]) - 1];
    let day = dateArray[0];
    let year = dateArray[2];

    let currentDate = day + ' ' + month + ' ' + year;
    return currentDate;
}


function getSharePriceData() {
    var ajax_data = {
        action: "vsl_share_price",
    };


    $('.block').each(function (index) {
        let block = $(this);
        let num = $(this).find('.block__number').data('num');
        let blockNum = $(this).find('.block__num');
        let tickerOptions = {
            decimalPlaces: 2,
            duration: 3,
        }

        if (num == 'share') {
            $.post("/wp-admin/admin-ajax.php", ajax_data, function (response) {
                let data = JSON.parse(response);
                let currentPrice = data.CurrentPrice;

                block.find('.block__date').text(constructDate(data));

                tickerOptions.suffix = 'p';
                let ticker = new CountUp(blockNum[0], currentPrice, tickerOptions);
                ticker.start();
            });
        } else {
            let number = parseFloat(num);
            let endChar = num[num.length - 1];

            tickerOptions.suffix = endChar;
            let ticker = new CountUp(blockNum[0], number, tickerOptions)
            ticker.start();
        }
    })
}
